import React from 'react';

interface Props {
  values: number[];
  color?: string;
  width?: number;
  height?: number;
  fill?: boolean;
}

const KpiSparkline: React.FC<Props> = ({ values, color = '#5B8C7E', width = 90, height = 24, fill = true }) => {
  if (!values || values.length < 2) {
    return <svg width={width} height={height} aria-hidden />;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const stepX = width / (values.length - 1);
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / span) * (height - 2) - 1;
    return [x, y] as const;
  });
  const path = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`).join(' ');
  const area = fill ? `${path} L ${width.toFixed(1)} ${height} L 0 ${height} Z` : '';

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden>
      {fill && <path d={area} fill={`${color}22`} stroke="none" />}
      <path d={path} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default KpiSparkline;
